module.exports = __webpack_public_path__ + "static/img/icon_j3.08d0bce6.png";